import { createContext, useContext, useEffect } from "react";

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./AuthContext";
import { authAxios } from "../Axios/createAxios";
import Cookie from "cookie-universal";
export const UserContext = createContext({});

export function UserProvider({ children }) {
  const { isAuth, checkAuth } = useAuth();
  const userData = async () => {
    try {
      const res = await authAxios.post(`/me`);
      return res;
    } catch (err) {
      throw err;
    }
  };
  const {
    isLoading,
    isSuccess,
    data = {},
  } = useQuery({
    queryKey: ["profile"],
    enabled: !!isAuth,
    queryFn: userData,
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (er) => {
      checkAuth();
      console.log(er);
    },
  });
  const userInfo = data?.data || {};

  return <UserContext.Provider value={{ userInfo, isLoading, isSuccess }}>{children}</UserContext.Provider>;
}
export const useIsVerified = () => {
  const { userInfo } = useContext(UserContext);
  return Boolean(userInfo?.email_verified_at);
};
